<template>
    <div>
        <h2>Entendendo a Ficha Técnica</h2>
        <p></p>
    </div>
</template>

<script>
export default {
    name:"ComoFoiCalculado",

};
</script>

<style>
</style>